import { render, staticRenderFns } from "./TabOpen.vue?vue&type=template&id=28cd467d"
import script from "./TabOpen.vue?vue&type=script&lang=js"
export * from "./TabOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports